import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner"; 
import client, { formatApiErrorDetail, setSessionExpiredHandler } from "@/api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); 
  
  // 1. DIUBAH: Cek token dari sessionStorage
  const [token, setToken] = useState(() => sessionStorage.getItem("access_token"));

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await client.get("/auth/me");
      setUser(data.user);
      
      // Jika endpoint /me juga memberikan token baru, kita amankan ke sessionStorage
      const newToken = data.access_token || data.token;
      if (newToken) {
        setToken(newToken);
        sessionStorage.setItem("access_token", newToken);
      }
    } catch {
      setUser(false);
      setToken(null);
      sessionStorage.removeItem("access_token");
    }
  }, []);

  useEffect(() => {
    setSessionExpiredHandler(() => {
      toast.error("Sesi Anda telah berakhir demi keamanan. Silakan login kembali.", {
        duration: 5000,
      });
      setUser(false);
      setToken(null);
      sessionStorage.removeItem("access_token"); // Bersihkan dari sessionStorage saat sesi habis
    });
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    try {
      const { data } = await client.post("/auth/login", { email, password });
      setUser(data.user);
      
      // 2. DIUBAH: Simpan token ke sessionStorage
      const receivedToken = data.access_token || data.token;
      if (receivedToken) {
        setToken(receivedToken);
        sessionStorage.setItem("access_token", receivedToken);
      }

      return { success: true };
    } catch (e) {
      return { success: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await client.post("/auth/logout");
    } catch (err) {
      console.error("Logout request failed, clearing local session anyway:", err);
    }
    setUser(false);
    setToken(null);
    sessionStorage.removeItem("access_token"); // Bersihkan dari sessionStorage saat logout
  };

  return (
    <AuthContext.Provider value={{ user, token, setUser, login, logout, refetch: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export const ROLE_LABELS = {
  super_admin: "Super Administrator",
  admin_dokumen: "Admin Dokumen",
  manager_department: "Manager Department",
  head_department: "Head Department",
  staff: "Staff Biasa",
  viewer: "Viewer (Hanya Lihat)",
};
